import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { TopBar } from './TopBar';
import { GlobalSearch } from './GlobalSearch';
import { MobileNav } from './MobileNav';

export default function AppLayout() {
  const [collapsed, setCollapsed] = useState(false);
  const [theme, setTheme] = useState<'dark' | 'light'>('dark');

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);

  return (
    <>
      <style>{`
        /* ─── Desktop ─────────────────────────── */
        @media (min-width: 768px) {
          .sidebar-desktop      { display: flex !important; }
          .lc-mobile-nav-root   { display: none !important; }
          .topbar-username      { display: inline !important; }
          .topbar-search-label  { display: inline !important; }
          .topbar-search-kbd    { display: inline-block !important; }
          .topbar-search        { min-width: 160px; }
          .main-content         { padding: 1.5rem !important; }
        }
        /* ─── Mobile ──────────────────────────── */
        @media (max-width: 767px) {
          .sidebar-desktop      { display: none !important; }
          .lc-mobile-nav-root   { display: block !important; }
          .topbar-username      { display: none !important; }
          .topbar-search-label  { display: none !important; }
          .topbar-search-kbd    { display: none !important; }
          .topbar-search        { padding: 0.375rem 0.5rem; min-width: unset; }
          .main-content         {
            padding: 1rem !important;
            /* spazio per la bottom bar floating (58px bar + 12px gap + safe area) */
            padding-bottom: calc(82px + env(safe-area-inset-bottom, 0px)) !important;
          }
        }
      `}</style>

      {/* Layout principale (flex row: sidebar | content) */}
      <div data-theme={theme} style={{
        display: 'flex',
        minHeight: '100dvh',
        maxWidth: '100vw',
        position: 'relative',
      }}>

        {/* Sidebar — solo desktop. Sticky wrapper: si ancora al viewport durante lo scroll.
            position:sticky nell'aside interno NON funziona perché overflowX:hidden sul
            contenitore flex crea uno scrolling context che spezza l'ancoraggio al viewport. */}
        <div
          className="sidebar-desktop"
          style={{
            display: 'none',
            flexShrink: 0,
            position: 'sticky',
            top: 0,
            alignSelf: 'flex-start',
            maxHeight: '100dvh',
            overflowY: 'auto',
          }}
        >
          <Sidebar collapsed={collapsed} onToggle={() => setCollapsed(c => !c)} theme={theme} onToggleTheme={() => setTheme(t => t === 'dark' ? 'light' : 'dark')} />
        </div>

        {/* Colonna contenuto */}
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0, maxWidth: '100%', overflow: 'hidden', position: 'relative', zIndex: 1 }}>
          <TopBar />
          <main
            className="main-content"
            style={{
              flex: 1,
              padding: '1.5rem',
              boxSizing: 'border-box',
              minWidth: 0,
              maxWidth: '100%',
              overflowX: 'hidden',
            }}
          >
            <Outlet />
          </main>
        </div>
      </div>

      {/* GlobalSearch — modale globale Cmd+K */}
      <GlobalSearch />

      {/* Navigazione mobile — FUORI dal flex, sempre position:fixed nel viewport */}
      <div className="lc-mobile-nav-root" style={{ display: 'none' }}>
        <MobileNav theme={theme} onToggleTheme={() => setTheme(t => t === 'dark' ? 'light' : 'dark')} />
      </div>
    </>
  );
}
